import { render, staticRenderFns } from "./AllocationLoader.vue?vue&type=template&id=89428f34&scoped=true"
import script from "./AllocationLoader.vue?vue&type=script&lang=ts&setup=true"
export * from "./AllocationLoader.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AllocationLoader.vue?vue&type=style&index=0&id=89428f34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89428f34",
  null
  
)

export default component.exports